module.exports = __webpack_public_path__ + "c391127af2118a87d9ad0bb6b7baa8a3.svg";